<div [innerHTML]="(svgIcon$ | async) ?? '' | sanitizeHtml"></div>
